<template>
  <div class="statement-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRule"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { totalDay } from '@/utils';
  export default {
    name: 'StatementRowTable',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      contractValid: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        baseTableRule: {},
        tableRule: {
          expenseName: [{ required: true, message: '费用名称必填', trigger: ['change', 'blur'] }],
          expenseStandard: [
            { required: true, message: '计费标准必填', trigger: ['change', 'blur'] },
          ],
          pricingUnit: [{ required: true, message: '计价单位必填', trigger: ['change', 'blur'] }],
          serviceCycle: [
            { required: true, message: '服务周期数必填', trigger: ['change', 'blur'] },
          ],
          perPeriodCost: [{ required: true, message: '每期费用必填', trigger: ['change', 'blur'] }],
          // billingCycle: [{ required: [].includes(), message: '计费周期必填', trigger: ['change', 'blur'] }],
        },
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenBtn: false,
        contractPricingUnitList: [],
        contractBillStandardsList: [],
        ids: [], // 被删除的数据id集合
        disabledServiceCycle: false, // 是否禁用服务周期
        totalDay: 0,
        disabledNumberLimit: true,
        disabledWeightLimit: true,
        disabledBillingCycle: true,
        billingCycleList: [],
        disabledGuaranteeQuantity: false, //是否禁用保底量
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'expenseName',
            title: '费用名称',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
            slots: {
              default: ({ row }) => {
                return [<span>{row['expenseName']}</span>];
              },
            },
          },
          {
            field: 'expenseStandard',
            title: '计费标准',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              events: {
                change: (obj) =>
                  this.expenseStandard(obj.row, obj.row['expenseStandard'], 'expenseStandard'),
              },
              options: this.contractBillStandardsList,
            },
            width: 150,
          },
          {
            field: 'pricingUnit',
            title: '计价单位',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {
                      this.contractPricingUnitList.find((item) => item.value == row['pricingUnit'])
                        ?.label
                    }
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <ElSelect
                    value={row.pricingUnit}
                    onChange={(val) => {
                      console.log(val, '当前值', row?.pricingUnitList);
                      // 处理时间
                      const $table = this.$refs.xTableRef;
                      const tableData = $table.getTableData().fullData;
                      if (row['expenseStandard'] == '01' && tableData.length > 1) {
                        if (val > tableData[1]['pricingUnit']) {
                          {
                            this.$message.error('当前计价单位必须小于之前的计价单位');
                          }
                          return (row['pricingUnit'] = '');
                        }
                      }
                      if (val == '01' && this.totalDay < 1) {
                        this.$message.warning(`有效期不满1天，是否继续新增`);
                      } else if (val == '02' && this.totalDay < 7) {
                        this.$message.warning(`有效期不满1周（7天），是否继续新增`);
                      } else if (val == '03' && this.totalDay < 30) {
                        this.$message.warning(`有效期不满1月（30天），是否继续新增`);
                      } else if (val == '04' && this.totalDay < 90) {
                        this.$message.warning(`有效期不满1季（90天），是否继续新增`);
                      } else if (val == '05' && this.totalDay < 365) {
                        this.$message.warning(`有效期不满1年（365天），是否继续新增`);
                      }
                      // 处理批次的时候
                      if (val == 11) {
                        this.disabledServiceCycle = true;
                        row['serviceCycle'] = 1;
                      } else {
                        this.disabledServiceCycle = false;
                        row['serviceCycle'] = '';
                      }

                      return (row['pricingUnit'] = val);
                    }}
                  >
                    {row?.pricingUnitList &&
                      row?.pricingUnitList?.map((item) => (
                        <ElOption value={item.value} label={item.label}></ElOption>
                      ))}
                  </ElSelect>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'serviceCycle',
            title: '服务周期数',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.serviceCycle, 0)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.serviceCycle}
                    max={999999999.999999}
                    min={0}
                    precision={0}
                    disabled={this.disabledServiceCycle}
                    onInput={(val) => this.chooseTable(val, row, 'serviceCycle')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'perPeriodCost',
            title: '每期费用',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.perPeriodCost)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.perPeriodCost}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'perPeriodCost')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'billingCycle',
            title: '计费周期',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
                // disabled: this.disabledBillingCycle,
              },
              // events: {
              //   change: (obj) =>
              //     this.expenseStandard(obj.row, obj.row['expenseStandard'], 'expenseStandard'),
              // },
              // options: this.billingCycleList,
            },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {
                      this.billingCycleList?.find((item) => item.value == row['billingCycle'])
                        ?.label
                    }
                  </span>,
                ];
              },
              // onChange={(val) => this.expenseStandard(row, val, 'expenseStandard')}
              edit: ({ row }) => {
                return [
                  <el-select
                    value={row['billingCycle']}
                    clearable={true}
                    disabled={row.disabledBillingCycle}
                    onChange={(val) => {
                      return (row['billingCycle'] = val);
                    }}
                  >
                    {this.billingCycleList?.map((item) => (
                      <ElOption value={item.value} label={item.label}></ElOption>
                    ))}
                  </el-select>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'includeTaxUnit',
            title: '含税单价',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.includeTaxUnit)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.includeTaxUnit}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'includeTaxUnit')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'pledgeWeight',
            title: '质押物重量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.pledgeWeight)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.pledgeWeight}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'pledgeWeight')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'pledgeQuantity',
            title: '质押物数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.pledgeQuantity)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.pledgeQuantity}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'pledgeQuantity')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'lowerWeightLimit',
            title: '重量下限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['lowerWeightLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['lowerWeightLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['lowerWeightLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledWeightLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'upperWeightLimit',
            title: '重量上限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['upperWeightLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['upperWeightLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['upperWeightLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledWeightLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'lowerNumberLimit',
            title: '数量下限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['lowerNumberLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['lowerNumberLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['lowerNumberLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledNumberLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'upperNumberLimit',
            title: '数量上限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['upperNumberLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['upperNumberLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['upperNumberLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledNumberLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'lowerDayLimit',
            title: '天数下限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['lowerDayLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['lowerDayLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['lowerDayLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledDayLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'upperDayLimit',
            title: '天数上限',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['upperDayLimit']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['upperDayLimit']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['upperDayLimit'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledDayLimit}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'guaranteeQuantity',
            title: '保底量',
            width: '140',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['guaranteeQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['guaranteeQuantity']}
                    max={999999999}
                    min={0}
                    precision={0}
                    onInput={(val) => (row['guaranteeQuantity'] = val)}
                    controls="false"
                    clearable={true}
                    disabled={row.disabledGuaranteeQuantity}
                    maxlength="10"
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
        ];
      },
    },
    mounted() {
      this.contractPricingUnitList = this.dictListMap.SuperviseContractPricingUnit;
      this.contractBillStandardsList = this.dictListMap.SuperviseContractBillStandards; // 计费标准
      this.billingCycleList = this.dictListMap?.billingCycleList; //计费时间
    },
    methods: {
      // 下拉框切换
      expenseStandard(row, fieldValue, field) {
        console.log(row, fieldValue, field, '计价标准');
        this.judgeDisabled(row, fieldValue);
        row['pricingUnit'] = '';
        row['pricingUnitList'] = this.filterUtil(fieldValue);
        row['lowerDayLimit'] = null;
        row['lowerNumberLimit'] = null;
        row['lowerWeightLimit'] = null;
        row['upperDayLimit'] = null;
        row['upperNumberLimit'] = null;
        row['upperWeightLimit'] = null;
        row['billingCycle'] = null;
        row['guaranteeQuantity'] = null;
      },
      judgeDisabled(row, fieldValue) {
        if (fieldValue == '02') {
          // 数量
          row.disabledNumberLimit = false;
          row.disabledWeightLimit = true;
          row.disabledBillingCycle = false;
          row.disabledDayLimit = true;
          row.disabledGuaranteeQuantity = false;
        } else if (fieldValue == '03') {
          // 重量
          row.disabledNumberLimit = true;
          row.disabledWeightLimit = false;
          row.disabledBillingCycle = false;
          row.disabledDayLimit = true;
          row.disabledGuaranteeQuantity = false;
        } else if (fieldValue == '05') {
          // 天数
          row.disabledNumberLimit = true;
          row.disabledWeightLimit = true;
          row.disabledBillingCycle = false;
          row.disabledDayLimit = false;
          row.disabledGuaranteeQuantity = true;
        } else {
          // 时间，一口价
          row.disabledNumberLimit = true;
          row.disabledWeightLimit = true;
          row.disabledBillingCycle = true;
          row.disabledDayLimit = true;
          row.disabledGuaranteeQuantity = true;
        }
        return {
          disabledNumberLimit: row.disabledNumberLimit,
          disabledWeightLimit: row.disabledWeightLimit,
          disabledBillingCycle: row.disabledBillingCycle,
          disabledDayLimit: row.disabledDayLimit,
          disabledGuaranteeQuantity: row.disabledGuaranteeQuantity,
        };
      },
      filterUtil(fieldValue) {
        if (fieldValue == '01') {
          // 时间
          return this.contractPricingUnitList.filter((item) =>
            ['01', '02', '03', '04', '05'].includes(item.value)
          );
        } else if (fieldValue == '02') {
          // 数量
          // return this.contractPricingUnitList.filter((item) =>
          //   ['06', '07', '08', '09'].includes(item.value)
          // );
          return this.contractPricingUnitList.filter((item) =>
            ['06', '13', '07'].includes(item.value)
          );
        } else if (fieldValue == '03') {
          // 重量
          return this.contractPricingUnitList.filter((item) => ['10', '12'].includes(item.value));
        } else if (fieldValue == '04') {
          // 一口价
          return this.contractPricingUnitList.filter((item) => ['11'].includes(item.value));
        } else if (fieldValue == '05') {
          // 天数
          return this.contractPricingUnitList.filter((item) => ['01'].includes(item.value));
        }
      },
      chooseTable(val, row, filed) {
        row[filed] = val;
      },
      handleSelectionChange(row) {
        console.log(row);
        this.selectionList = row.selection;
      },
      // 新增一行
      async addNewRowHandler() {
        const { contractValidFrom, contractValidUntil } = this.contractValid;
        if (!contractValidFrom || !contractValidUntil) {
          this.$message.error('请选择合同开始时间和结束时间');
          return;
        }
        // if (!contractValidFrom) {
        //   this.$message.error('请选择合同开始时间');
        //   return;
        // }
        this.totalDay = totalDay(contractValidFrom, contractValidUntil);
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt(
          {
            expenseName: '监管费',
            disabledNumberLimit: true,
            disabledWeightLimit: true,
            disabledBillingCycle: true,
            disabledDayLimit: true,
          },
          0
        );
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        console.log(this.selectionList, '选择的');
        const XIDList = this.selectionList.map((item) => item._XID);
        console.log(XIDList, '11111111', this.tableData);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 关闭表格
      closeEditTableHandler() {
        // 计算合同金额
        console.log('计算合同金额', this.$refs.xTableRef.getTableData().fullData);
        let tableData = this.$refs.xTableRef.getTableData().fullData;
        // tableData = tableData.map((item)=>{
        //   return {
        //     ...item,
        //     totalAmount:item.serviceCycle*item.perPeriodCost,
        //   }
        // })
        const totalAmount = tableData.reduce(
          (pre, item) => pre + +item.serviceCycle * +item.perPeriodCost,
          0
        );
        this.$emit('setAmount', totalAmount);
      },
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          console.log(tableData, '表格数据');
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            if (valid && tableData.length) {
              const currentStatus = this.$route.query.status;
              const isCopyStatus =
                ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01';
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  // 特殊处理id
                  id: isCopyStatus ? null : item?.id,
                  gmtCreate: isCopyStatus ? null : item?.gmtCreate,
                  gmtModified: isCopyStatus ? null : item?.gmtModified,
                  // 数量，重量,天数上下限
                  lowerLimit: item.lowerWeightLimit || item.lowerNumberLimit || item.lowerDayLimit,
                  upperLimit: item.upperWeightLimit || item.upperNumberLimit || item.upperDayLimit,
                };
              });
              resolve({ tableData: formTableData, deleteSettlementLineIds: this.ids });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [], deleteSettlementLineIds: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData.map((item) => {
          console.log(this.judgeDisabled(item, item.expenseStandard), '限制条件');
          return {
            ...item,
            pricingUnitList: this.filterUtil(item.expenseStandard),
            lowerWeightLimit: item.expenseStandard == '03' ? item.lowerLimit : null,
            lowerNumberLimit: item.expenseStandard == '02' ? item.lowerLimit : null,
            lowerDayLimit: item.expenseStandard == '05' ? item.lowerLimit : null,
            upperWeightLimit: item.expenseStandard == '03' ? item.upperLimit : null,
            upperNumberLimit: item.expenseStandard == '02' ? item.upperLimit : null,
            upperDayLimit: item.expenseStandard == '05' ? item.upperLimit : null,
            ...this.judgeDisabled(item, item.expenseStandard),
          };
        });
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  // .statement-table {
  //   ::v-deep {
  //     .el-input-number {
  //       span {
  //         display: none !important;
  //       }
  //     }
  //   }
  // }
</style>
